import { tv } from 'tailwind-variants'

export const borderRadius = tv({
  base: 'rounded-none',
  variants: {
    radius: {
      none: 'rounded-none',
      xsmall: 'rounded-sm',
      small: 'rounded',
      normal: 'rounded-lg',
      medium: 'rounded-xl',
      large: 'rounded-2xl',
      xlarge: 'rounded-3xl',
      xxlarge: 'rounded-4xl',
      xxxlarge: 'rounded-5xl',
      full: 'rounded-full',
    },
  },
})
